import { Trans } from '@lingui/macro'
import { Grid } from '@material-ui/core'
import { dateFormat } from 'app/appSettings'
import CustomDatePicker from 'app/views/common/CustomDatePicker'
import { useField, useFormikContext } from 'formik'
import moment from 'moment'
import React, { useState } from 'react'

import { useSelector } from 'react-redux'
import { PreviouslySavedValuesPanel } from '../../GroupElement'
import {
  endEditingField,
  startEditingField,
  unlockFieldWithoutChanges
} from '../../multiuser/grpcMultiuserEdit'
import { MuEditedByLabel } from '../Common'

const MUDatePicker = ({
  id,
  formikRef,
  useMultiuser,
  displayFieldHistoryIcon = false,
  preventEndEditingEvent = false,
  onChange,
  muBag,
  ...props
}) => {
  const [editedValue, setEditedValue] = useState(null)
  const { values, setFieldTouched, setFieldValue } = useFormikContext()
  const user = useSelector(state => state.user)
  const [field, meta] = useField(id)
  const { muInfo, muUsers = {} } = values
  const muState = muInfo[id]
  let userColor, userName, isEdited
  if (muState) {
    const { user, locked } = muState
    if (locked) {
      isEdited = true
      userColor = muUsers[user]?.color
      userName = muUsers[user]?.name
    }
  }
  let marginBottom = 0
  const style = { ...props.style }
  if (style && style.marginBottom) {
    marginBottom = style.marginBottom || style.margin || 0
    if (isEdited) {
      delete style.marginBottom
    }
  }
  const error = props.error || meta.error
  const isError = error && meta.touched

  const component = (
    <Grid container direction='column'>
      <CustomDatePicker
        {...field}
        {...props}
        disabled={
          props.disabled ||
          Boolean(muState && muState.locked && muState.user !== user.userId)
        }
        error={isError}
        helperText={isError ? error : props.helperText}
        color={userColor}
        handleOpen={e => {
          setEditedValue(moment.utc(field.value).format(dateFormat))
          startEditingField({
            ...muBag,
            fieldId: id
          })
        }}
        onChange={e => {
          if (onChange) {
            onChange(e)
          } else {
            setFieldValue(id, e)
          }
          if (useMultiuser) {
            endEditingField({
              ...muBag,
              fieldId: id,
              fieldValue: e,
              lockId: values.muInfo.lockId
            })
          }
        }}
        handleClose={date => {
          if (!meta.touched) {
            setFieldTouched(id)
          }
          if (useMultiuser) {
            const passedDate = moment.utc(date).format(dateFormat)
            if (!date || passedDate === editedValue) {
              unlockFieldWithoutChanges({
                ...muBag,
                fieldId: id,
                lockId: values.muInfo.lockId
              })
            } else {
              //Handle if user opened dialog, changed date and clicked cancel
              setTimeout(() => {
                const currentValue = formikRef.current.values[id]
                if (
                  !currentValue ||
                  passedDate !== moment.utc(currentValue).format(dateFormat)
                ) {
                  unlockFieldWithoutChanges({
                    ...muBag,
                    fieldId: id,
                    lockId: values.muInfo.lockId
                  })
                }
              }, 500)
            }
          }
        }}
      />
      <div style={{ marginBottom: marginBottom }}>
        <MuEditedByLabel color={userColor} userName={userName} />
      </div>
    </Grid>
  )

  if (displayFieldHistoryIcon) {
    return (
      <Grid
        container
        direction='row'
        justifyContent='center'
        alignItems='center'
        style={style}
      >
        <Grid item xs>
          {component}
        </Grid>
        <Grid item>
          <PreviouslySavedValuesPanel
            disabled={props.disabled}
            muBag={muBag}
            fieldId={id}
            type='datePicker'
            //connectedObject={connectedObject}
            //item={item}
            useMultiuser={useMultiuser}
          />
        </Grid>
      </Grid>
    )
  } else {
    return component
  }
}

export default MUDatePicker
